// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"229":"e709da30","234":"b05d0e0a","258":"36a33272","521":"6efb5459","750":"a1455505","912":"3ea30471","923":"cef98e4a"}[chunkId] + ".chunk.js";
};